export class SmoothValue {
    /**
     * Aktualni hodnota. Nastavenim se zastavi pripadna probihajici zmena.
     */
    get value(): number { return this._value; }
    set value(val: number) {
        this._value = val;
        this._changeTargetVal = val;
    }
    private _value: number;

    /**
     * Hodnota, ze ktere se hlavni hodnota meni
     */
    private _changeStartVal: number;
    /**
     * Hodnota, do ktere se ma hlavni hodnota zmenit
     */
    private _changeTargetVal: number;
    /**
     * Cas zacatku zmeny
     */
    private _changeTime: number;
    /**
     * Ease funkce zmeny
     */
    private _changeEase: (k: number) => number;
    /**
     * Delka zmeny v ms
     */
    private _changeLen: number;
    /**
     * Tag pro stav hodnoty
     */
    valueStateTag: number;

    /**
     * (RO) True, pokud probiha zmena hodnoty
     */
    get isValueChanging(): boolean { return this._value != this._changeTargetVal; }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    startChange(curTime: number, targetVal: number, changeEase: (k: number) => number, changeLen: number): void {
        this._changeStartVal = this._value;
        this._changeTargetVal = targetVal;
        this._changeTime = curTime;
        this._changeEase = changeEase;
        this._changeLen = changeLen;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(time: number): number {
        if (this._value != this._changeTargetVal) {
            let progress = (time - this._changeTime) / this._changeLen;

            if (progress >= 1) {
                this._value = this._changeTargetVal;
            }
            else {
                this._value = this._changeStartVal + (this._changeTargetVal - this._changeStartVal) * this._changeEase(progress);
            }
        }

        return this._value;
    }
}